import React from 'react';
import AgentSearch from './AgentSearch.js';

var BlockAgentSearch = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$search = attrs.search,
      search = _attrs$search === void 0 ? 'zip' : _attrs$search,
      _attrs$placeholder = attrs.placeholder,
      placeholder = _attrs$placeholder === void 0 ? 'Enter Zip Code' : _attrs$placeholder,
      disabled = attrs.disabled;
    return /*#__PURE__*/React.createElement(AgentSearch, {
      search: search,
      placeholder: placeholder,
      disabled: disabled
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/agent-search',
    title: 'Agent Search',
    description: 'Search for agents',
    icon: 'businessperson',
    keywords: ['searches', 'agents', 'premier'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Search',
    attributes: {
      search: {
        type: 'string',
        default: 'zip',
        label: 'Search Type',
        control: 'select',
        choices: [{
          label: 'Zip',
          value: 'zip'
        }, {
          label: 'Installations',
          value: 'installation'
        }]
      },
      placeholder: {
        type: 'string',
        label: 'Placeholder',
        default: 'Enter Zip Code',
        control: 'text'
      }
    }
  }
};
var BlockAgentSearch$1 = BlockAgentSearch;

export { BlockAgentSearch$1 as default };
